import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImageHelper";
import Modal from "react-modal"; 

const ImageCropperModal = ({ image, onCropComplete, onClose, acceptRatio }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropCompleteHandler = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleDone = async () => {
    const croppedImage = await getCroppedImg(image, croppedAreaPixels);
    onCropComplete(croppedImage);
    setTimeout(()=>{onClose();},10);
  };
  function onClick(){
    onClose();
  }

  return (
    <Modal isOpen onRequestClose={onClose} >
      <div
        className="crop-container"
        style={{ position: "relative", height: 400, width: "100%" }}
      >
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect= {acceptRatio} 
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropCompleteHandler}
        />
      </div>
      <div className="btns-grp text-right mt-3">
        <button type="button" className="backbutton" onClick={()=>onClick()}>
          Cancel
        </button>
        <button type="button" className="savebtn-click" onClick={handleDone}>
          Crop & Save
        </button>
      </div>
    </Modal>
  );
};

export default ImageCropperModal;
